import { SingletonEnginnering } from "../singletonEngineering"
import ValueOnStrucutre from "./valueOnStructureEnginnering"

const Writer = {
  setWithProperty: function(prop){
   let structure =  SingletonEnginnering.structureOfEnginnering 
    ValueOnStrucutre.set(structure, prop)
    this.save(structure)
  },

  setWithMapping(mapping, value){
    let prop = SingletonEnginnering.getPropertieByToken(mapping)
    this.setWithProperties(prop, value)
  },

  save(structure){
    if(!structure) return
    this.saveLocalStorage(structure)
    this.saveInMemory(structure)
  },
  saveLocalStorage(structure){
    let xml = JSON.parse(localStorage.xml)
    xml.scenarioObjectStructure = structure;
    localStorage.xml = JSON.stringify(xml)
  },
  saveInMemory(struncture){
    SingletonEnginnering.structureOfEnginnering = struncture
  }
}

export default Writer